import { baseUrl } from "@/config/index.js";
const config: {
  base_url: string;
  result_code: number;
  token_invalid_code: number;
  error_code: 500;
  default_headers: GlobalAxiosHeadersType;
  request_timeout: number;
} = {
  /**
   * api请求基础路径
   */
  base_url: baseUrl,
  result_code: 0,
  token_invalid_code: 900,
  error_code: 500,
  request_timeout: 60000,
  default_headers: "application/json;charset=UTF-8",
};

export { config };
